module.exports = __webpack_public_path__ + "static/media/163.bf484466.mp3";